<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Navigate',
})
</script>
<template>
  <a-card title="站点导航">
    <template #extra>
      <a-button  type="primary" @click="onAdd(0)">
      <PlusOutlined />
      </a-button>
    </template>

    <a-tree
        :tree-data="dataSource"
        :blockNode="true"
        :autoExpandParent="true"
        :fieldNames="{title:'text',key:'id',children:'child'}"
        :show-line="true"
      >
      <template #title="{id,text,child}">
          <span style="margin-right: 50px">{{ text }}</span>
          <a-button-group>
            <a-button size="small" type="primary" @click="onAdd(id)">
                <PlusOutlined />
            </a-button>
            <a-button size="small" type="primary" @click="onEdit(id)">
                <EditOutlined />
            </a-button>
            <a-button v-if="child.length===0" size="small" type="primary" @click="onDel(id)">
                <DeleteOutlined />
            </a-button>
          </a-button-group>
      </template>
    </a-tree>
      <lanseed-form ref="form" v-model:open="open" :data="model" :rules="rules" @change="submit">
      </lanseed-form>
  </a-card>
</template>
<script setup lang="ts" name="Navigate">
import api from '@/utils/http/service'
import {addip} from '@/utils/util'
import { onMounted, ref,reactive } from 'vue'
import {PlusOutlined,EditOutlined,DeleteOutlined} from '@ant-design/icons-vue'
import LanseedForm from '@/components/lanseed/form.vue'
const open=ref<boolean>(false)
const dataSource=ref<Array>([])
const rules={
    title:{domtype:'input',name:'名称',required:true},
    cname:{domtype:'input',name:'目标',desc:'生成静态HTML的名称'},
    url:{domtype:'input',name:'url',desc:'链接地址'},
    num:{domtype:'number',name:'排序'},
    pic:{domtype:'img',name:'图标',data:[{id:4,text:'第一个'},{id:7,text:'第二个'}]},
    main:{domtype:'radio',name:'类型',data:[{id:0,text:'主菜单'},{id:1,text:'底部菜单'},{id:2,text:'两者'}]},
  }
let model=ref<any>({})
onMounted(()=>{
  getList()
})
  const getList=():void=>{
      api.sitemenu.list({}).then(res=>{
        dataSource.value=res.data
      })
  }
const onAdd=(id:number):void=>{
    model.value={title:'',cname:'',num:0,ID:0,pid:id,pic:'',url:'',main:0,grade:0}
    open.value=true
  }
  const onEdit=(id:number):void=>{
    api.sitemenu.get(id).then(res=>{
        model.value=res.data
        open.value=true
        getList()
    })
  }
  const onDel=(id:number):void=>{
    api.sitemenu.del(id).then(res=>{
        getList()
    })
  }
  const submit=(d:object):void=>{
    api.sitemenu.add(d).then(res=>{
     if(res.state==1){
       open.value=false
        getList()
     }
    })
  }

</script>
